export enum FormControlStatus {
  VALID = 'VALID',
  INVALID = 'INVALID',
  DISABLED = 'DISABLED',
  PENDING = 'PENDING'
}
